<template>
  <div class="item-big" v-for="type in types" :key="type.id">
    <div class="content">
      <h3>{{ type.title }}:</h3>
      <p>{{ type.description }}</p>
    </div>
    <img
      v-for="img in type.imgs"
      :key="img.id"
      :src="getImageTeamPath(img)"
      alt="icon"
    />
  </div>
</template>

<script>
export default {
  name: "grc-types-item-big",
  props: {
    types: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getImageTeamPath(item) {
      return require(`@/assets/images/grc/${item}.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-big {
  width: 100%;
  display: flex;
  padding: 25px;
  border: 1px solid #1c1c1c;
  gap: 46px;

  @media (max-width: 767px) {
    max-width: unset !important;
    position: relative;
    height: 470px !important;
    min-width: 298px;
  }
  @media (max-width: 1360px) {
    height: 372px;
    max-width: 42%;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 340px;
    width: 100%;

    p {
      max-width: 200px;
      font-family: UAF Sans;
      font-weight: 400;
      font-size: 24px;
      line-height: 30px;

      @media (max-width: 767px) {
        font-size: 18px;
        line-height: 21px;
      }
    }
  }

  &:first-child {
    max-width: 785px;

    p {
      max-width: 527px;
    }
  }

  h3 {
    font-family: "UAF Sans HR", serif;
    font-weight: 600;
    font-size: 24px;
    line-height: 100%;

    @media (max-width: 767px) {
      width: 298px;
    }
  }

  img {
    width: 412px;
    @media (max-width: 1360px) {
      display: none;
    }

    &:last-child {
      margin-left: auto;
      margin-right: 0;
      @media (max-width: 1360px) {
        width: 300px;
        margin-top: 18px;
        position: absolute;
        display: block;
      }
      @media (max-width: 767px) {
        width: 240px;
        margin-top: 18px;
        position: absolute;
        display: block;
        top: 77px;
      }
    }
  }

  p {
    margin-bottom: 0;
    margin-top: auto;
  }
}
</style>
